import React from 'react';

import { TStickyPosition } from 'types/utils';

type TParams = {
  onStick(position: null | TStickyPosition): void;
};

// TODO: сделать грамотную реализациюю, которая будет возвращать
// массив с идентификаторами сторон, находящихся за пределами
// viewport'а. Вся часть с Object.assign() должна выполняться
// снаружи, так как имеет сугубо локальное значение.

export const useSticky = (
  targetRef: React.RefObject<HTMLDivElement>,
  params: TParams
) => {
  const { onStick } = params;

  const callback = React.useCallback(
    (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        const { boundingClientRect, intersectionRect, target } = entry;
        if (boundingClientRect.bottom > intersectionRect.bottom) {
          if (target instanceof HTMLElement) {
            Object.assign(target.style, {
              width: boundingClientRect.width + 'px',
              height: boundingClientRect.height + 'px',
            });
          }
          onStick('bottom');
        } else {
          if (target instanceof HTMLElement) {
            Object.assign(target.style, {
              width: null,
              height: null,
            });
          }
          onStick(null);
        }
      });
    },
    [onStick]
  );

  const observerRef = React.useRef(
    new IntersectionObserver(callback, { threshold: [0, 1] })
  );

  React.useEffect(() => {
    const { current: observer } = observerRef;
    const { current: targetNode } = targetRef;

    if (targetNode) {
      observer.observe(targetNode);

      return () => {
        observer.unobserve(targetNode);
      };
    }
  }, [targetRef]);
};
